import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { normalizeScreen } from '@etap/shared';
import { initMetrica, trackHit } from '../lib/analytics';
import { trackAppEvent, trackSessionStart } from '../lib/appEvents';

export function useAnalytics() {
  const location = useLocation();
  const enteredAtRef = useRef<number>(Date.now());
  const previousScreenRef = useRef<string | null>(null);

  useEffect(() => {
    initMetrica();
    trackSessionStart();
  }, []);

  useEffect(() => {
    const path = `${location.pathname}${location.search}`;
    trackHit(path || '/');

    const screen = normalizeScreen(location.pathname);
    const now = Date.now();
    const previous = previousScreenRef.current;

    // Длительность считаем не по самому экрану, а по переходу с него:
    // так она попадает в событие уже завершившегося просмотра и не требует
    // отдельного «экран закрыт», которое всё равно теряется при выходе.
    trackAppEvent(
      'screen_viewed',
      {
        screen,
        from: previous,
        previousSeconds: previous ? Math.round((now - enteredAtRef.current) / 1000) : null,
      },
      { screen },
    );

    previousScreenRef.current = screen;
    enteredAtRef.current = now;
  }, [location.pathname, location.search]);
}
